import React from "react";

const spacingClass = {
  0: "gap-0",
  1: "gap-1",
  2: "gap-2",
  3: "gap-3",
  4: "gap-4",
  5: "gap-5",
  6: "gap-6",
  8: "gap-8",
};

const colSpanClass = {
  1: "col-span-1",
  2: "col-span-2",
  3: "col-span-3",
  4: "col-span-4",
  5: "col-span-5",
  6: "col-span-6",
  7: "col-span-7",
  8: "col-span-8",
  9: "col-span-9",
  10: "col-span-10",
  11: "col-span-11",
  12: "col-span-12",
  true: "col-span-12",
  auto: "col-auto",
};

const breakpointColSpan = {
  sm: {
    1: "sm:col-span-1", 2: "sm:col-span-2", 3: "sm:col-span-3", 4: "sm:col-span-4",
    5: "sm:col-span-5", 6: "sm:col-span-6", 7: "sm:col-span-7", 8: "sm:col-span-8",
    9: "sm:col-span-9", 10: "sm:col-span-10", 11: "sm:col-span-11", 12: "sm:col-span-12",
  },
  md: {
    1: "md:col-span-1", 2: "md:col-span-2", 3: "md:col-span-3", 4: "md:col-span-4",
    5: "md:col-span-5", 6: "md:col-span-6", 7: "md:col-span-7", 8: "md:col-span-8",
    9: "md:col-span-9", 10: "md:col-span-10", 11: "md:col-span-11", 12: "md:col-span-12",
  },
  lg: {
    1: "lg:col-span-1", 2: "lg:col-span-2", 3: "lg:col-span-3", 4: "lg:col-span-4",
    5: "lg:col-span-5", 6: "lg:col-span-6", 7: "lg:col-span-7", 8: "lg:col-span-8",
    9: "lg:col-span-9", 10: "lg:col-span-10", 11: "lg:col-span-11", 12: "lg:col-span-12",
  },
};

/**
 * Lightweight stand-in for MUI's 12-column Grid. `container` renders a
 * `grid grid-cols-12`; `item` children span columns via xs/sm/md/lg.
 */
const Grid = ({
  container = false,
  item = false,
  spacing = 0,
  xs,
  sm,
  md,
  lg,
  className = "",
  children,
  ...rest
}) => {
  if (container) {
    return (
      <div
        className={`grid grid-cols-12 ${spacingClass[spacing] || spacingClass[0]} ${className}`}
        {...rest}
      >
        {children}
      </div>
    );
  }

  if (item) {
    const cols = [
      colSpanClass[xs] || "col-span-12",
      sm ? breakpointColSpan.sm[sm] : "",
      md ? breakpointColSpan.md[md] : "",
      lg ? breakpointColSpan.lg[lg] : "",
    ].join(" ");

    return (
      <div className={`${cols} ${className}`} {...rest}>
        {children}
      </div>
    );
  }

  return (
    <div className={className} {...rest}>
      {children}
    </div>
  );
};

export default Grid;
